// extracted by mini-css-extract-plugin
export default {"button":"Calculator_button__vOCQR","button__calc__wrap":"Calculator_button__calc__wrap__jIlUa","router__calc":"Calculator_router__calc__QVB2U","hidden":"Calculator_hidden__Ikn+e"};